'use strict';

const { Component } = require('phy');
const FetchHandler = require('../../deal/frontend/FetchHandler');

class SelectWidgetBaseContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { isUserStatusSet: null };
  }

  componentDidMount() {
    this.lazyLoadUserStatus();
  }

  lazyLoadUserStatus() {
    const handler = new FetchHandler({
      url: '/deals/user_proxy/select_enrollment_status',
      requestOpts: { credentials: 'same-origin' },
      successHandlers: userStatus =>
        this.setState({ isUserStatusSet: true, ...userStatus }),
      errorHandlers: () => this.setState({ isUserStatusSet: false }),
    });
    handler.send();
  }

  // render in touch and desktop child classes
  // render() {}
}

module.exports = SelectWidgetBaseContainer;
